export function cs(){
    setTimeout(() => {
        console.log('cs')
    }, 1000)
}